import { Link } from "react-router-dom";
import { Reveal, Stagger, StaggerItem } from "../components/Motion";
import { consultations, doctor } from "../lib/data";
import { ArrowRight, Check } from "lucide-react";

export default function Consultations() {
  return (
    <div data-testid="page-consultations">
      <section className="pt-32 md:pt-40 pb-16">
        <div className="container-luxe grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="overline mb-6">Консультації</div>
            </Reveal>
            <Reveal delay={0.05}>
              <h1 className="font-serif text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight">
                Чесна розмова про
                <br />Ваше обличчя.
              </h1>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 text-warmGray text-lg max-w-xl leading-relaxed">
                Жодних шаблонів і нав’язування. На консультації ми разом визначаємо
                реалістичні цілі, дивимось аналізи та будуємо персональний протокол.
              </p>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-5">
            <img loading="lazy" decoding="async" src="/generated/consultation_hero.webp"
              alt="Консультація"
              className="w-full h-[460px] object-cover rounded-3xl"
            />
          </Reveal>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-luxe">
          <Reveal>
            <div className="overline mb-3">Формати</div>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight max-w-2xl">
              Оберіть зручний формат
            </h2>
          </Reveal>
          <Stagger className="mt-12 grid md:grid-cols-2 gap-x-10 gap-y-2 max-w-4xl">
            {consultations.map((c) => (
              <StaggerItem key={c}>
                <div className="flex items-start gap-4 py-5 border-b border-line">
                  <Check size={18} strokeWidth={1.2} className="mt-1 text-warmGray shrink-0" />
                  <div>{c}</div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>

          <Reveal>
            <Link
              to="/booking"
              data-testid="consult-book-cta"
              className="mt-14 inline-flex items-center gap-2 rounded-full bg-ink text-bone px-8 py-4 text-[11px] tracking-[0.28em] uppercase hover:bg-black transition"
            >
              Записатися на консультацію <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
